module.exports = __webpack_public_path__ + "static/media/banner.8eb9cf8c.jpeg";